class EditorialMListContent extends HTMLElement {
  constructor() {
    super();

    this.mListAccordions = this.querySelectorAll('.editorial-m-list-content__accordion .accordion');

    this.openAccordions();
  }

  connectedCallback() {}

  disconnectedCallback() {}

  openAccordions() {
    if (window.innerWidth < 990) {
      this.mListAccordions.forEach((accordion) => {
        const details = accordion.querySelector('details');
        const summary = accordion.querySelector('summary');

        details.setAttribute('open', 'true');
        summary.setAttribute('aria-expanded', 'true');
      });
    }
  }
}

customElements.define('editorial-m-list-content', EditorialMListContent);
